"use client";

import TestRunner from "@/components/teste/TestRunner";
import type { PublicTherapistSummary } from "@/actions/getTherapists";
import {
  stimaDeSineConfig,
  type SelfEsteemCategory,
} from "@/data/tests/stima-de-sine";
import { captureStimaDeSineLead, submitStimaDeSineTest } from "./actions";

/**
 * The Rosenberg scale wired into the shared runner.
 *
 * A client component because the config carries functions; the page passes
 * only the therapist list. No urgent category: a low score on this scale is
 * not a crisis signal, and the page's crisis note covers anyone who is.
 */
export default function StimaDeSineRunner({
  therapists,
}: {
  therapists: PublicTherapistSummary[];
}) {
  return (
    <TestRunner<SelfEsteemCategory>
      config={stimaDeSineConfig}
      submit={submitStimaDeSineTest}
      capture={captureStimaDeSineLead}
      therapists={therapists}
      zenyra={{
        topic: "stima-de-sine",
        prefill: (score) =>
          `Am facut testul de stima de sine (Scala Rosenberg) pe Mindtale si scorul meu este ${score}/30. Vreau sa povestim despre felul in care ma privesc si ce pot face mai departe.`,
      }}
      emailCopy={{
        headline: "Vreau să primesc rezultatul și câteva exerciții",
        body: "Rezultatul detaliat și câteva exerciții scurte despre felul în care te tratezi. Fără spam, te dezabonezi oricând.",
        submitLabel: "Trimite-mi rezultatul",
      }}
    />
  );
}
